/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_ALL_TRACKS = createAsyncAction('GET_ALL_TRACKS')
export const getAllTracks = (page = 1) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/reviews/all/${page}`,
    types: GET_ALL_TRACKS,
  })

export const GET_AWAITING_TRACKS = createAsyncAction('GET_AWAITING_TRACKS')
export const getAwaitingTracks = (page = 1) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/reviews/awaiting_review/${page}`,
    types: GET_AWAITING_TRACKS,
  })

export const GET_REVIEWED_TRACKS = createAsyncAction('GET_REVIEWED_TRACKS')
export const getReviewedTracks = (page = 1) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/reviews/reviewed/${page}`,
    types: GET_REVIEWED_TRACKS,
  })

export const GET_MISSED_TRACKS = createAsyncAction('GET_MISSED_TRACKS')
export const getMissedTracks = (page = 1) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/reviews/missed/${page}`,
    types: GET_MISSED_TRACKS,
  })

export const GET_CANCELLED_TRACKS = createAsyncAction('GET_CANCELLED_TRACKS')
export const getCancelledTracks = (page = 1) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/reviews/cancelled/${page}`,
    types: GET_CANCELLED_TRACKS,
  })

export const SEND_REVIEW = createAsyncAction('SEND_REVIEW')
export const sendReview = (
  // eslint-disable-next-line camelcase
  campaign_id: number | string,
  comment: string,
  value: {
    type: string
    id: number | string
  },
  callback: (msg: string, error: { response: { status: number } }) => void
) =>
  apiCall({
    method: 'put',
    endpoint: '/review',
    query: {
      campaign_id,
      comment,
      value,
    },
    types: SEND_REVIEW,
    callback,
  })

export const SET_CURATOR_SCORE = 'SET_CURATOR_SCORE'

// TODO not used
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setCuratorScore = (payload: any) => ({
  type: SET_CURATOR_SCORE,
  payload,
})

export const GET_WORDS_BLACKLIST = createAsyncAction('GET_WORDS_BLACKLIST')
export const getWordsBlacklist = () =>
  apiCall({
    method: 'get',
    endpoint: '/review/blacklist',
    types: GET_WORDS_BLACKLIST,
  })

export const GET_REJECT_REASONS = createAsyncAction('GET_REJECT_REASONS')
export const getRejectReasons = () =>
  apiCall({
    method: 'get',
    endpoint: '/review/reject-reasons',
    types: GET_REJECT_REASONS,
  })

export const GET_CURATOR_STATS = createAsyncAction('GET_CURATOR_STATS')
export const getCuratorStats = () =>
  apiCall({
    method: 'get',
    endpoint: `/review/curators-stats`,
    types: GET_CURATOR_STATS,
  })

export const GET_REVIEW_DETAILS = createAsyncAction('GET_REVIEW_DETAILS')
export const getReviewDetails = (
  id: number,
  callback: (
    error: string,
    response: {
      campaign_id: number
      id: number | string
      is_feed: boolean | string
    }
  ) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `review/details/${id}`,
    types: GET_REVIEW_DETAILS,
    callback,
  })

export const GET_SELECTED_CURATOR_STATS = createAsyncAction(
  'GET_SELECTED_CURATOR_STATS'
)
export const getSelectedCuratorStats = (id: number | string) =>
  apiCall({
    method: 'get',
    endpoint: `/admin/curator-stats/${id}`,
    types: GET_SELECTED_CURATOR_STATS,
  })

export const RESPOND_TO_REVIEW = createAsyncAction('RESPOND_TO_REVIEW')
export const respondToReview = (
  respond: string,
  reviewId: number | string,
  rating: number,
  callback: (error: string) => void
) =>
  apiCall({
    method: 'post',
    endpoint: '/review/respond',
    query: {
      respond,
      review_id: reviewId,
      rating,
    },
    types: RESPOND_TO_REVIEW,
    callback,
  })

export const SKIP_REVIEW = createAsyncAction('SKIP_REVIEW')
export const skipReview = (
  review_id: number,
  campaign_id: number,
  callback: (err: string) => void
) =>
  apiCall({
    method: 'post',
    endpoint: '/review/skip',
    query: {
      review_id,
      campaign_id,
    },
    types: SKIP_REVIEW,
    callback,
  })
